import React, { useState, useRef, useEffect } from 'react'
import { Collapse, Row, Col, Card, Button, Tooltip, Popconfirm, Table } from 'antd'
import { chooseEmailModalFxn, DisplayDate, GetDownloadLink } from '../../../components/_utils/appUtils'
import ReactHtmlParser from 'react-html-parser'
import { RowTable, CustomCardTitle } from '../../article/articleView/RowTable'
import _ from 'lodash'
import { SendTemplateEmail } from '../../email/actions'
import { useDispatch } from 'react-redux'
import { getPushPathWrapper } from '../../../routes'
import AddCourierDrawer from '../drawer/addCourierDrawer'
import { TableComp } from 'sz-react-utils-lite'
import AddPaymentDrawer from '../drawer/addPaymentDrawer'
import Request from '../../../request'

const { Panel } = Collapse


const GeneralSubscriptionDetails = (props) => {
  let { article, courierData } = props
  const [articleData, setArticleData] = useState(article)
  const dispatch = useDispatch()
  const [couriers, setCouriers] = useState(article.courierDetails || [])
  const [visibleDrawer, setVisibleDrawer] = useState(false)
  const [missingIssue, setMissingIssue] = useState()
  const [visiblePaymentDrawer, setVisiblePaymentDrawer] = useState({
    visible: false,
    totalAmount: '',
    invoiceId: ''

  })
  const [state, setState] = useState({

    journalNameList: [],
    journalVolumeList: []

  })
  const table = useRef()
  const events = {

    showDrawer: data => {
      setMissingIssue(data)
      setVisibleDrawer(true)
    },
    hideDrawer: data => {
      setMissingIssue('')
      setVisibleDrawer(false)

    },
    showPaymentDrawer: (data, _id) => {
      setVisiblePaymentDrawer({ visible: true, totalAmount: data, invoiceId: _id })
    },
    hidePaymentDrawer: data => {
      setVisiblePaymentDrawer({ visible: false, totalAmount: '', invoiceId: '' })

    },
    getJournalList: async () => {
      let { data } = await Request.journalName()
      let journalList = []
      _.each(data, item => {
        journalList.push({
          _id: item._id,
          value: item.slugJournal,
          display: item.name
        })
      })
      setState(prevState => ({
        ...prevState,
        journalNameList: journalList
      }))
    },

    getJournalsVolumeData: async () => {
      let { data } = await Request.getJournalsVolumeList()
      let volumeList = []
      _.each(data, (item) => {
        volumeList.push({
          _id: item._id,
          name: item.volumeName
        })
      })
      setState(prevState => ({
        ...prevState,
        journalVolumeList: volumeList
      }))
    }
  }
  useEffect(() => {
    events.getJournalList()
    events.getJournalsVolumeData()
  }, [])

  const handlePaymentAdded = (data) => {
    let updatedInvoiceStatus = articleData.invoiceData && articleData.invoiceData.status

    setArticleData({
      ...articleData,
      invoiceData: {
        status: updatedInvoiceStatus
      }
    })
    setVisiblePaymentDrawer({ visible: false })
  }
  let sendMailFxn = (article) => {
    chooseEmailModalFxn({
      callback: async (email) => {
        let obj = {
          id: article._id,
          fromEmail: email,
          emailType: 'acknowledgement',
          template: article.processingCharges > 0 ? 'acknowledgementWithCharges' : 'acknowledgementWithoutCharges',
          type: 'article'
        }
        let resp = await dispatch(SendTemplateEmail({
          email: obj.fromEmail,
          id: article._id,
          obj,
          template: obj.template
        }))
        if (resp && resp.success) {
          dispatch({ type: 'START_LOAD_ARTICLE' })
        }
      }
    })
  }

  let BtnAction = (event) => {
    // events.show()
    event.stopPropagation()
    sendMailFxn(article)
  }


  let getExtraButton = () => {
    return (
      <>
        <React.Fragment>

          <Button type={'primary'} size={'small'} onClick={() => {
            events.showDrawer()
          }}>Add Courier</Button>
        </React.Fragment>
        <React.Fragment>


        </React.Fragment>

      </>

    )
  }
  let getMissingIssueButton = () => {
    return (
      <>
        <React.Fragment>

          <Button type={'primary'} size={'small'} onClick={() => {
            events.showDrawer(true)
          }}>Add Missing Issues</Button>
        </React.Fragment>
        <React.Fragment>


        </React.Fragment>

      </>

    )
  }
  let tableColumn = [
    {
      title: 'Journal Name',
      name: 'courierDetails',
      key: 'courierDetails',
      dataIndex: 'courierDetails',
      width: 400,
      render: (courierDetailsArray, index) => {
        if (!courierDetailsArray || courierDetailsArray.length === 0) return '-'
        const journalNames = courierDetailsArray.map(item => {
          const journalItem = state.journalNameList.find(j => j._id === item.journal)
          return journalItem ? journalItem.display : '-'
        })
        return <>{journalNames.join(', ')}</>
      }
    },
    {
      title: 'Date',
      name: 'date',
      key: 'date',
      dataIndex: 'date',
      width: 400,
      render: data => {
        return DisplayDate(data)
      }
    },

    {
      title: 'Volume',
      name: 'courierDetails',
      key: 'courierDetails',
      dataIndex: 'courierDetails',
      render: (courierDetailsArray, index) => {
        if (!courierDetailsArray || courierDetailsArray.length === 0) return '-'
        const IssuesNames = courierDetailsArray.map(item => {
          return item.volumeName
        })
        return <>{IssuesNames.join(', ')}</>
      }
    },
    {
      title: 'Issues',
      name: 'courierDetails',
      key: 'courierDetails',
      dataIndex: 'courierDetails',
      render: (courierDetailsArray, index) => {
        if (!courierDetailsArray || courierDetailsArray.length === 0) return '-'
        const IssuesNames = courierDetailsArray.map(item => {
          return item.issues
        })
        return <>{IssuesNames.join(', ')}</>
      }
    },
    {
      title: 'Copies',
      name: 'courierDetails',
      key: 'courierDetails',
      dataIndex: 'courierDetails',
      render: (courierDetailsArray, index) => {
        if (!courierDetailsArray || courierDetailsArray.length === 0) return '-'
        const IssuesNames = courierDetailsArray.map(item => {
          return item.copies
        })
        return <>{IssuesNames.join(', ')}</>
      }
    }
  ]
  let paymentColumn = [
    {
      title: 'Received Date',
      name: 'receivedDate',
      key: 'receivedDate',
      dataIndex: 'receivedDate',
      width: 400,
      render: data => {
        return DisplayDate(data)
      }
    },
    {
      title: 'Mode Of Payment',
      name: 'modeOfPayment',
      key: 'modeOfPayment',
      dataIndex: 'modeOfPayment'
    },
    {
      title: 'Amount',
      name: 'amount',
      key: 'amount',
      dataIndex: 'amount'
    }
  ]
  let invoiceColumn = [
    {
      title: 'Invoice Date',
      name: 'date',
      key: 'date',
      dataIndex: 'date',
      width: 400,
      render: data => {
        return DisplayDate(data)
      }
    },
    {
      title: 'Invoice No',
      name: 'invoiceNo',
      key: 'invoiceNo',
      dataIndex: 'invoiceNo'
    },
    {
      title: 'Invoice Status',
      name: 'status',
      key: 'status',
      dataIndex: 'status'
    },
    {
      title: 'Invoice',
      name: 'invoice',
      key: 'invoice',
      dataIndex: 'invoice',
      width: 400,
      render: data => {
        return (
          <>
            {data &&
              data.path && (
                <a
                  href={data.path}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='ml20'
                >
                  Download Invoice
                </a>
              )}
          </>
        )
      }
    },

    {
      key: 'actions',
      title: 'Actions',
      width: 150,
      render: (val, record) => (

        <React.Fragment>
          {record.status != 'done' && (
            <Button
              type='primary'
              size='small'
              onClick={() => {
                events.showPaymentDrawer(record && record.totalAmount, record._id)
              }}
            >
              Add Payment
            </Button>
          )}
        </React.Fragment>
      )
    }
  ]
  return (
    <>
      <Collapse defaultActiveKey={['1']} expandIconPosition={'right'}>
        <Panel header='General Subscription Details' key='1' expandIconPosition='right'>
          <div className={'tableBox striped'}>

            <RowTable title={'Name'} value={article.name} />
            <RowTable title={'Email'} value={article.email} />
            <RowTable title={'Mobile'} value={article.mobile} />
            <RowTable title={'Address'} value={article.address} />

            {article.designation && (
              <RowTable title={'Designation'} value={article.designation} />
            )}
            {article.contactPerson && (
              <RowTable title={'Contact Person'} value={article.contactPerson} />
            )}
            {article.agencyName && (
              <RowTable title={'Agency Name'} value={article.agencyName} />
            )}
            <RowTable title={'Pincode'} value={article.pincode} />
            <RowTable title={'Country'} value={article.country} />
            <RowTable title={'State'} value={article.state} />
            <RowTable title={'City'} value={article.city} />
            <RowTable title={'Subscribe By'} value={article.subscribeBy} />
            <RowTable title={'Status'} value={article.status} />
            {article.instituteName && (
              <RowTable title={'Institute Name'} value={article.instituteName} />

            )}
            {article.instituteContactPerson && (
              <RowTable title={'Institute Contact Person'} value={article.instituteContactPerson} />

            )}
            {article.instituteContactNo && (
              <RowTable title={'Institute Contact No'} value={article.instituteContactNo} />

            )}
            {article.instituteAddress && (
              <RowTable title={'Institute Address'} value={article.instituteAddress} />
            )}
          </div>

        </Panel>

        <Panel header='Invoice Details' expandIconPosition='right'>
          <div className={'tableBox striped'}>
            {/*<RowTable title={'Invoice Date'} value={DisplayDate(article.invoiceData && article.invoiceData.date)} />*/}

            {/*<RowTable*/}
            {/*  title="Invoice"*/}
            {/*  value={*/}
            {/*    <>*/}

            {/*      {article &&*/}
            {/*      article &&*/}
            {/*      article.invoice &&*/}
            {/*      article.invoice.path && (*/}
            {/*        <a*/}
            {/*          href={article.invoice.path}*/}
            {/*          target="_blank"*/}
            {/*          rel="noopener noreferrer"*/}
            {/*          className="ml20"*/}
            {/*        >*/}
            {/*          Download Invoice*/}
            {/*        </a>*/}
            {/*      )}*/}
            {/*    </>*/}
            {/*  }*/}
            {/*/>*/}
            {/*<RowTable title={'Invoice Status'} value={article.invoiceData && article.invoiceData.status} />*/}
            <TableComp
              className='figureTable'
              bordered
              pagination={false}
              columns={invoiceColumn}
              dataSource={article.invoiceData
              }
            />
          </div>

        </Panel>
        <Panel header='Payment Details'>

          <div className={'tableBox striped'}>
            <TableComp
              className='figureTable'
              bordered
              pagination={false}
              columns={paymentColumn}
              dataSource={article.paymentDetails
              }
            />

            {/*<RowTable title={'Received Date'}  value={`${DisplayDate(article.receivedDate)}`}  />*/}
            {/*<RowTable title={'Mode Of Payment'}  value={`${article.modeOfPayment}`}  />*/}
            {/*<RowTable title={'Amount'}  value={`INR ${article.totalAmount}`}  />*/}
          </div>

        </Panel>
        <Panel header='Courier Details' extra={getExtraButton()}>

          <TableComp
            className='figureTable'
            bordered
            pagination={false}
            columns={tableColumn}
            dataSource={courierData && courierData.filter(item => !item.missingIssues)}
          />
        </Panel>
        <Panel header='Missing Issues' extra={getMissingIssueButton()}>

          <TableComp
            className='figureTable'
            bordered
            pagination={false}
            columns={tableColumn}
            dataSource={courierData && courierData.filter(item => item.missingIssues)}
          />
        </Panel>
      </Collapse>
      {visibleDrawer && (
        <AddCourierDrawer visible={visibleDrawer} reloadData={props.reloadData} invoiceData={article.invoiceData}
                          missingIssues={missingIssue}
                          onClose={() => setVisibleDrawer(false)} />
      )}

      {visiblePaymentDrawer.visible && (
        <AddPaymentDrawer      {...visiblePaymentDrawer}
                               reloadData={props.reloadData}
                               onPaymentAdded={handlePaymentAdded}
                               onClose={() => events.hidePaymentDrawer()} />
      )}

    </>

  )

}

export default GeneralSubscriptionDetails
